import { PublicDeviceFilterState } from "@/components/devices/PublicDeviceFilters";

interface PublicDevice {
  device_id: string;
  device_name: string;
  device_description?: string | null;
  device_last_updated: string;
  lat_wgs84: number | null;
  long_wgs84: number | null;
  past_images?: any[];
  imageKit?: {
    thumbnailUrl?: string;
    fullUrl?: string;
  };
}

export const filterAndSortPublicDevices = (
  devices: PublicDevice[],
  filters: PublicDeviceFilterState
): PublicDevice[] => {
  let filtered = [...devices];

  // Apply search filter
  if (filters.search) {
    const searchLower = filters.search.toLowerCase();
    filtered = filtered.filter(
      (device) =>
        device.device_name?.toLowerCase().includes(searchLower) ||
        device.device_description?.toLowerCase().includes(searchLower)
    );
  }

  // Apply sorting
  filtered.sort((a, b) => {
    switch (filters.sortBy) {
      case 'name':
        return (a.device_name || '').localeCompare(b.device_name || '');
      
      case 'recent':
        const dateA = a.device_last_updated ? new Date(a.device_last_updated).getTime() : 0;
        const dateB = b.device_last_updated ? new Date(b.device_last_updated).getTime() : 0;
        return dateB - dateA; // Most recent first
      
      case 'location':
        const locA = a.device_name || '';
        const locB = b.device_name || '';
        return locA.localeCompare(locB);
      
      default:
        return 0;
    }
  });

  return filtered;
};
